import { render, staticRenderFns } from "./birthdateInput.vue?vue&type=template&id=610bd588&"
import script from "./birthdateInput.vue?vue&type=script&lang=js&"
export * from "./birthdateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('610bd588', component.options)
    } else {
      api.reload('610bd588', component.options)
    }
    module.hot.accept("./birthdateInput.vue?vue&type=template&id=610bd588&", function () {
      api.rerender('610bd588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/UserProfile/Scripts/Inputs/birthdateInput.vue"
export default component.exports